import { useEffect, useRef } from 'react';
import { Card, CardActions, CardContent, CardHeader, IconButton, Tooltip, Typography } from '@mui/material';
import { UsageModel } from '../../models/plan-metrics.model';
import ProgressBar from "./progress-bar.component";
import GirdCellLoaderAminationData from "../shared/loaders/grid-cell-loader.json";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import { InformationIcon } from '../../icon';

interface Props {
    title: string;
    tooltip?: string;
    Data: UsageModel;
    IsMobileDevice: boolean;
    avatar: any;
    IsTeamsApp?: boolean;
    ShowLoader?: boolean;
    CardColor?: string;
    ProgressTitle: string;
}

const Tier_Card = (props: Props) => {
    const ref = useRef<any>()
    useEffect(() => {
        ref.current.parentElement.className = `${ref.current.parentElement.className} tool-icon-center`;

    }, [])


    return (
        <Card className={`box-shadow-none br-4 w-p-100 ${props.CardColor} ${props.IsMobileDevice ? 'h-p-65 d-flex flex-direction justify-around pt-2 pb-2' : 'h-p-100'}`}>
            <CardHeader className={`${props.IsMobileDevice ? "px-1 py-0" : "px-2 pt-2 p-0"} `}
                title={props.IsMobileDevice ? props.title : props.avatar}
                classes={{ title: `${props.IsMobileDevice && "h4 color-secondary"}` }}
                action={<div ref={ref} className="d-flex" >
                    {props.IsMobileDevice ? props.avatar :
                        <Tooltip title={props.tooltip} placement="bottom-end" enterTouchDelay={props.IsMobileDevice ? 100 : 0} classes={{ tooltip: `${props.IsMobileDevice && "h5"}` }}>
                            <IconButton size="small" className={`${props.IsMobileDevice ? 'mt-1 pr-2 py-2' : 'p-2'}`}>
                                <InformationIcon />
                            </IconButton>
                        </Tooltip>}
                </div>
                }
            />
            {
                !!props.ShowLoader ?
                    <CardContent className={`d-flex ${props.IsMobileDevice ? '' : 'py-3'} `} >
                        <AnimateLoader LoaderAnimation={GirdCellLoaderAminationData} className={props.IsMobileDevice ? "w-6 h-3" : ""} />
                    </CardContent>
                    :
                    <CardContent className={`${props.IsMobileDevice ? "" : `${props.Data.GetPercentile() < 60 ? 'progress-green' : props.Data.GetPercentile() < 90 ? 'progress-orange' : 'progress-red'}`} ${props.IsMobileDevice ? 'px-1' : 'pb-2 mtn-1 px-2 p-0'}`} >
                        <p className={`p-relative color-secondary ${props.IsMobileDevice ? 'h1 w-space m-0 mb-1' : 'h6-regular'}`} >
                            <span style={{ color: "white" }}>{props.IsMobileDevice ? "" : "Credits Used:"}&nbsp; {props.Data.UsedCredits}</span> <span className={`${props.IsMobileDevice && "h4"}`} style={{ color: "white" }}>out of</span> <span style={{ color: "white" }}>{props.Data.TotalCredits}</span></p>
                        {!props.IsMobileDevice && <ProgressBar {...props} Title={props.ProgressTitle} IsMobileDevice={props.IsMobileDevice} />}
                    </CardContent>
            }
            {
                !props.IsMobileDevice && <CardActions className={`px-2 pb-1 p-0 d-block mt-1`}>
                    <Typography className={`h4-regular `} style={{ color: "white" }}>{props.title}</Typography>
                    <div className={"mt-1 dashboard-line m-0 mb-2 w-6"} style={{ color: "white" }}></div>
                </CardActions>
            }
        </Card >
    );
}
export default Tier_Card